module.exports = __webpack_public_path__ + "img/dashboard-main-desktop-fr.88bc8034.jpg";